Vue.config.productionTip = false

import App from './App.vue'
import Storage from 'vue-ls'
import router from './router'
import store from './store/'
import '@/permission'
import { colorList } from '@/components/tools/setting.js'
import { getAction, deleteAction, postAction } from '@/api/manage'

import {
  ACCESS_TOKEN,
  DEFAULT_COLOR,
  DEFAULT_THEME,
  DEFAULT_LAYOUT_MODE,
  DEFAULT_COLOR_WEAK,
  SIDEBAR_TYPE,
  DEFAULT_FIXED_HEADER,
  DEFAULT_FIXED_HEADER_HIDDEN,
  DEFAULT_FIXED_SIDEMENU,
  DEFAULT_CONTENT_WIDTH_TYPE,
  DEFAULT_MULTI_PAGE
} from '@/store/mutation-types'
import config from '@/defaultSettings'

import hasPermission from '@/utils/hasPermission'
import JDictSelectTag from './components/dict/JDictSelectTag'
import JInputPopup from './components/JInputPopup'
import JModal from './components/JModal'
import JSlash from './components/JSlash'
import JEmpty from './components/JEmpty'
import JSharp from './components/JSharp'
import JSort from './components/JSort'
import JArrow from './components/JArrow'
import ApplyModal from '@/views/k00/k0011/modules/ApplyModal'
import uploader from 'vue-simple-uploader'
//import JUpload from './components/JUpload'
//import JBigFileUpload from './components/JBigFileUpload'
import JUpload from './components/JBigFileUpload'

//import { install } from '@icon-park/vue/es/all'
//install(Vue, 'i')

Vue.use(Storage, config.storageOptions)
Vue.use(hasPermission)
Vue.use(uploader)
Vue.component('j-dict-select-tag', JDictSelectTag)
Vue.component('JDictSelectTag', JDictSelectTag)
Vue.component('j-input-popup', JInputPopup)
Vue.component('JInputPopup', JInputPopup)
Vue.component('j-modal', JModal)
Vue.component('JModal', JModal)
Vue.component('j-slash', JSlash)
Vue.component('JSlash', JSlash)
Vue.component('j-empty', JEmpty)
Vue.component('JEmpty', JEmpty)
Vue.component('j-sharp', JSharp)
Vue.component('JSharp', JSharp)
Vue.component('j-sort', JSort)
Vue.component('JSort', JSort)
Vue.component('j-arrow', JArrow)
Vue.component('JArrow', JArrow)
Vue.component('apply-modal', ApplyModal)
Vue.component('ApplyModal', ApplyModal)
Vue.component('j-upload', JUpload)
Vue.component('JUpload', JUpload)
//Vue.component('j-bigfile-upload', JBigFileUpload)
//Vue.component('JBigFileUpload', JBigFileUpload)

Vue.prototype.moment = moment
Vue.prototype.localStorage = localStorage
Vue.prototype.sessionStorage = sessionStorage

// 引入datav
import dataV from '@jiaminghi/data-view'
// 按需引入vue-awesome图标
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/chart-bar.js'
import 'vue-awesome/icons/chart-area.js'
import 'vue-awesome/icons/chart-pie.js'
import 'vue-awesome/icons/chart-line.js'
import 'vue-awesome/icons/align-left.js'

//hong@2022-04-16 改为cdn引入
//引入echart
//4.x 引用方式
//import echarts from 'echarts'
//5.x 引用方式为按需引用
//希望使用5.x版本的话,需要在package.json中更新版本号,并切换引用方式
//import * as echarts from 'echarts'
//Vue.prototype.$echarts = echarts

// 全局注册
Vue.component('icon', Icon)
Vue.use(dataV)

// 多言語対応
import Vue18n from 'vue-i18n'
Vue.use(Vue18n)

import zh_CN from './locales/zh-cn.json'
//import ja_JP from './locales/ja-jp.json'

window.locales = [
  {
    value: 'zh_CN',
    text_ja_JP: '日文',
    text_zh_CN: '中文'
  }
  //{
  //  value: 'ja_JP',
  //  text_ja_JP: '日本語',
  //  text_zh_CN: '中国語'
  //}
]

// デフォルト言語
if (!Vue.ls.get('Locale')) {
  Vue.ls.set('Locale', window.locales[0].value)
}

window.locales.forEach(element => {
  document.body.classList.remove(element.value)
})
document.body.classList.add(window.locales[0].value)

const i18n = new Vue18n({
  locale: Vue.ls.get('Locale'),
  messages: {
    zh_CN: zh_CN
    //ja_JP: ja_JP
  }
})

// 时间格式化
import moment from 'moment'
//moment.updateLocale('zh-cn', {
//  weekdaysMin: ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
//})
Vue.filter('dateformat', function(dataStr, pattern) {
  return dataStr ? moment(dataStr).format(pattern) : null
})

// 配置ant组件默认设置 start
antd.Select.props.allowClear.default = true
antd.TreeSelect.props.allowClear.default = true

antd.InputNumber.props.max.default = 9999999999

antd.Table.props.size.default = 'middle'
antd.Table.props.bordered.default = true
antd.Table.props.tableLayout.default = 'auto'
antd.Table.props.rowKey.default = 'id'
antd.Table.Column.props.align.default = 'left'
//antd.Table.props.locale.default = () => {
//  return {
//    emptyText: 'No Data'
//  }
//}

antd.Input.TextArea.props.autoSize.default = () => {
  return {
    minRows: 1
  }
}

antd.Descriptions.props.bordered.default = true
antd.Descriptions.props.size.default = 'small'
antd.Descriptions.props.column.default = () => {
  return {
    xs: 1,
    sm: 2,
    md: 3,
    lg: 3,
    xl: 3,
    xxl: 3
  }
}

antd.DatePicker.RangePicker.props.separator.default = '～'
antd.Collapse.props.bordered.default = false

// Modal
antd.Modal.props.maskClosable.default = false
antd.Modal.props.keyboard.default = false
antd.Modal.props.destroyOnClose.default = true
antd.Modal.props.okText.default = i18n.t('disp.btn.confirm')
antd.Modal.props.okButtonProps.default = () => {
  return {
    props: {
      icon: 'check'
    }
  }
}
antd.Modal.props.cancelButtonProps.default = () => {
  return {
    props: {
      icon: 'close',
      type: 'ghost'
    }
  }
}

// InputNumber
antd.InputNumber.props.formatter.default = function(value) {
  if (!value) return value
  var result = value
  //console.info('formatter: ' + result)

  // 输入框
  if (this.$el) {
    var inputDom = this.$el.querySelector('.ant-input-number-input')
  }

  // 单位
  var unitAttr = inputDom ? inputDom.closest('[unit]') : null

  if (event && (event.data == '.' || event.data == '0')) {
    if (inputDom && inputDom == event.currentTarget) {
      result = `${result}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

      if (unitAttr) {
        result = result + ' ' + unitAttr.attributes['unit'].value
      }

      return result
    }
  }

  if (XEUtils.isNumber(result)) {
    result = result + ''
  }

  var arr = result.split('.')

  // 有小数
  if (arr.length > 1) {
    arr[1] = arr[1].rtrim('0')

    // 小数位全是0
    if (arr[1] == '') {
      var result = arr[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    } else {
      var result = arr[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + arr[1]
    }
  }
  // 无小数
  else {
    var result = `${result}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }

  if (unitAttr) {
    var pos = result.length
    inputDom.setSelectionRange(pos, pos)

    result = result + ' ' + unitAttr.attributes['unit'].value
  }

  return result
}
antd.InputNumber.props.parser.default = function(value) {
  //console.info('parser: ' + value)
  //var result = value.replace(/\$\s?|(,*)/g, '')

  //var match = result.match(/[0-9]+(.?[0-9]*)/g)
  //if (match.length > 0) {
  //  result = XEUtils.trim(match[0])
  //} else {
  //  return undefined
  //}
  var result = ''
  var minus = ''

  if (value.startsWith('-')) {
    value = value.substr(1)
    minus = '-'
  }

  var hasDot = false
  for (let char of value) {
    if (!XEUtils.isNaN(parseInt(char))) {
      result = result + char
    }

    if (char === '.' && !hasDot) {
      hasDot = true
      result = result + char
    }
  }

  //console.log(minus + result)
  return minus + result
}

// Drawer
antd.Drawer.props.maskClosable.default = false
antd.Drawer.props.keyboard.default = false
antd.Drawer.props.destroyOnClose.default = true

// Popconfirm
antd.Popconfirm.props.okText.default = i18n.t('disp.btn.confirm')
antd.Popconfirm.props.placement.default = 'topRight'

// DatePicker
antd.DatePicker.props.valueFormat.default = 'YYYY-MM-DD'
antd.DatePicker.props.getCalendarContainer.default = function(triggerNode) {
  return determineContainer(triggerNode)
}

// TimePicker
antd.TimePicker.props.getPopupContainer.default = function(triggerNode) {
  return determineContainer(triggerNode)
}

// MonthPicker
antd.DatePicker.MonthPicker.props.getCalendarContainer.default = function(triggerNode) {
  return determineContainer(triggerNode)
}

// RangePicker
antd.DatePicker.RangePicker.props.getCalendarContainer.default = function(triggerNode) {
  return determineContainer(triggerNode)
}

// Select
antd.Select.props.getPopupContainer.default = function(triggerNode) {
  return determineContainer(triggerNode)
}

antd.message.config({
  top: '44px'
})

function determineContainer(triggerNode) {
  if (!window.openedPicker) {
    window.openedPicker = []
  }

  if (triggerNode.__vue__.parent) {
    window.openedPicker.push(triggerNode.__vue__.parent)
  }

  document.querySelectorAll('.router-view-wrapper, .ant-modal-body').forEach(selector => {
    selector.addEventListener('scroll', function(e) {
      window.openedPicker.forEach(item => {
        if (item && item.close) {
          item.close()
        }
      })
    })
  })

  if (
    triggerNode.closest('.div-complex-table-wrapper') ||
    triggerNode.closest('.ant-table-row') ||
    triggerNode.closest('.ant-modal-body') ||
    triggerNode.closest('.ant-input-group')
  ) {
    return window.document.body
  } else {
    return triggerNode.parentNode
  }
}

antd.BackTop.props.visibilityHeight.default = 200
antd.BackTop.props.target.default = function() {
  return document.querySelector('.router-view-wrapper')
}

antd.FormModel.methods['validateFieldsAndScroll'] = function(e, t) {
  var that = this

  that.validate(ok => {
    if (ok) {
      var firstError = that.$el.querySelector('.ant-form-item-with-help')
      if (firstError) {
        firstError.scrollIntoViewIfNeeded()
      } else {
        e(true)
      }
    } else {
      that.$nextTick(() => {
        var firstError = that.$el.querySelector('.ant-form-item-with-help')
        if (firstError) {
          firstError.scrollIntoViewIfNeeded()
        }
      })
    }
  })
}
// Vue.use(Antd)
// 配置ant组件默认设置 end

// 全局混入
import globalMixin from './mixins/globalMixin'
Vue.mixin(globalMixin)

const primaryColors = Vue.observable({
  instance: {
    primaryColorKey: '',
    primaryColorValue: '',
    primary2ColorKey: '',
    primary2ColorValue: '',
    primary3ColorKey: '',
    primary3ColorValue: '',
    primary4ColorKey: '',
    primary4ColorValue: ''
  }
})
Object.defineProperty(Vue.prototype, '$primaryColors', {
  get() {
    return primaryColors.instance
  },

  set(value) {
    primaryColors.instance = value
  }
})

// 修复XEUtils的bug：当数组具备自定义原型链的时候,即使数组为空也会进入for循环
if (XEUtils.isEmpty) {
  XEUtils.isEmpty = function(n) {
    if (Array.isArray(n)) {
      if (n.length == 0) {
        return true
      } else {
        return false
      }
    }

    for (var t in n) return !1
    return !0
  }
}

window.vm = new Vue({
  router,
  store,
  i18n,
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    store.commit('SET_SIDEBAR_TYPE', Vue.ls.get(SIDEBAR_TYPE, true))
    store.commit('TOGGLE_THEME', Vue.ls.get(DEFAULT_THEME, config.navTheme))
    localStorage.removeItem('pro__DEFAULT_THEME')
    store.commit('TOGGLE_LAYOUT_MODE', Vue.ls.get(DEFAULT_LAYOUT_MODE, config.layout))
    store.commit('TOGGLE_FIXED_HEADER', Vue.ls.get(DEFAULT_FIXED_HEADER, config.fixedHeader))
    store.commit('TOGGLE_FIXED_SIDERBAR', Vue.ls.get(DEFAULT_FIXED_SIDEMENU, config.fixSiderbar))
    store.commit('TOGGLE_CONTENT_WIDTH', Vue.ls.get(DEFAULT_CONTENT_WIDTH_TYPE, config.contentWidth))
    store.commit('TOGGLE_FIXED_HEADER_HIDDEN', Vue.ls.get(DEFAULT_FIXED_HEADER_HIDDEN, config.autoHideHeader))
    store.commit('TOGGLE_WEAK', Vue.ls.get(DEFAULT_COLOR_WEAK, config.colorWeak))
    store.commit('TOGGLE_COLOR', Vue.ls.get(DEFAULT_COLOR, config.primaryColor))
    store.commit('SET_TOKEN', Vue.ls.get(ACCESS_TOKEN))
    store.commit('SET_MULTI_PAGE', Vue.ls.get(DEFAULT_MULTI_PAGE, config.multipage))
  },
  methods: {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  render: h => h(App)
})
export default window.vm

// 挂载 less.js and ui-color.less
if (!Vue.ls.get(DEFAULT_COLOR)) {
  Vue.ls.set(DEFAULT_COLOR, config.primaryColor)
}

setTimeout(() => {
  const lessStyleNode = document.createElement('link')
  const lessConfigNode = document.createElement('script')
  const lessScriptNode = document.createElement('script')
  lessStyleNode.setAttribute('rel', 'stylesheet/less')
  lessStyleNode.setAttribute('href', '/ui-color.less')
  lessConfigNode.innerHTML = `
    window.less = {
      async: true,
      env: 'production',
      javascriptEnabled: true
    };
  `
  lessScriptNode.src = '/less.min.js'
  lessScriptNode.async = true
  lessScriptNode.onload = () => {
    buildIt(Vue.ls.get(DEFAULT_COLOR))
    lessScriptNode.onload = null
  }
  document.body.appendChild(lessStyleNode)
  document.body.appendChild(lessConfigNode)
  document.body.appendChild(lessScriptNode)
}, 1)

// import {
//   Icon
// } from 'ant-design-vue';

function buildIt(primaryColor) {
  // 正确的判定less是否已经加载less.modifyVars可用
  if (!window.less || !window.less.modifyVars) {
    return
  }

  antd.Icon.setTwoToneColor(primaryColor)

  var primary = XEUtils.first(XEUtils.filter(colorList, r => r.color == primaryColor))
  var primary1 = XEUtils.first(XEUtils.filter(colorList, r => r.key == primary.primary1))
  var primary2 = XEUtils.first(XEUtils.filter(colorList, r => r.key == primary.primary2))
  var primary3 = XEUtils.first(XEUtils.filter(colorList, r => r.key == primary.primary3))
  var primary4 = XEUtils.first(XEUtils.filter(colorList, r => r.key == primary.primary4))

  Vue.prototype.$colorList = colorList
  Vue.prototype.$primaryColors = {
    primaryColorKey: primary.key,
    primaryColorValue: primary.color,
    primary1ColorKey: primary1.key,
    primary1ColorValue: primary1.color,
    primary2ColorKey: primary2.key,
    primary2ColorValue: primary2.color,
    primary3ColorKey: primary3.key,
    primary3ColorValue: primary3.color,
    primary4ColorKey: primary4.key,
    primary4ColorValue: primary4.color
  }

  // less.modifyVars可用
  window.less
    .modifyVars({
      '@primary-color': primary.color,
      '@primary1-color': primary1.color,
      '@primary2-color': primary2.color,
      '@primary3-color': primary3.color,
      '@primary4-color': primary4.color
    })
    .then(() => {
      // 刷新页面时,重新获取一些共通信息
      if (
        vm.$route.name != 'login' &&
        vm.$route.fullPath != '/503'
      ) {
        vm.$getDict(null, null, true)
        vm.$getDepartTree(null, true)
        vm.$getPosition(null, true)
        vm.$getBizLine(null, true)
        sessionStorage.removeItem('SYS_COMPANY_TREE')

        getAction('/blaze-sys/sys/clearUserCache', null).then(res => {})
      }

      vm.$mount('#app')
      document.body.classList.remove('no-progress')
    })
    .catch(e => {
      console.error('Failed to update theme')
    })
}

